import {toCurrency} from 'utils/helpers';

export const DetailRow = ({label, value, valueClassName}) => (
    <li className="list-group-item d-flex justify-content-between align-items-start py-2 gap-2 px-0 bg-transparent">
        <h5 className="text-nowrap m-0">{label}</h5>
        <h5 className={`fw-semibold text-end m-0 ${valueClassName || ''}`}>{value}</h5>
    </li>
);

const LASGInvoiceCard = ({invoiceData}) => {
    const {payerName, agencyName, reference, amountDue, revName} = invoiceData || {};

    return (
        <div className="bg-light border rounded-3 p-3 mb-4">
            <p className="text-uppercase fw-bold text--gray mb-4" style={{letterSpacing: '0.6px'}}>
                Invoice Details
            </p>
            <ul className="list-group list-group-flush space-y-6">
                <DetailRow label="Payer" value={payerName} />
                <DetailRow label="Agency" value={agencyName} />
                <DetailRow label="Services" value={revName} />
                <DetailRow label="Reference" value={reference} />
                <DetailRow
                    label="Amount Due"
                    value={`₦${toCurrency(amountDue)}`}
                    style={{color: 'var(--primary-fill)'}}
                />
            </ul>
        </div>
    );
};

export default LASGInvoiceCard;
